<template lang="pug">
.headline
    h2.headline__title {{$t('pages.ssrGiftCards.headline.title')  }}
    .headline__text(v-html="$t('pages.ssrGiftCards.headline.text')")
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.headline {
  display: flex;
  flex-direction: column;
  gap: $gap;

  &__title {
    font-weight: 700;
    font-size: 32px;
    color: #ffffff;
  }

  &__text {
    color: #ffffff;
  }
}
</style>
